import React, { Fragment } from "react";
import ClassNames from "classnames";
import { SERVICE_TYPES } from "Constants/commonConstants";
import { ReactComponent as FTLIcon } from "Icons/ftl-road.svg";
import { ReactComponent as LCLIcon } from "Icons/lcl-express.svg";
import { ReactComponent as CourierIcon } from "Icons/courier.svg";
import { ReactComponent as ContainerIcon } from "Icons/container.svg";
import { FlexWrapperT14 } from "Components/Common/Wrapper/FlexWrapper";
import { Spacer } from "Components/Common/Spacer/index";
import { LabelT6 } from "Components/Common/Label/index";
const ServiceTypeDetails = (props) => {
  const {
    serviceTypesList,
    handleOnClickServiceType,
    serviceTypeValue = {},
  } = props;

  const isSelected = (serviceTypeEle) => {
    const C1 = serviceTypeValue.service_type === serviceTypeEle.value;
    if (C1) {
      return true;
    }
    return false;
  };

  return (
    <Fragment>
      <LabelT6>Service Type</LabelT6>
      <Spacer spacing={"3px"} />
      <FlexWrapperT14>
        {serviceTypesList.map((serviceType, index) => {
          return (
            <Fragment key={index}>
              {
                <div
                  className={ClassNames(
                    "border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10 pr curP",
                    {
                      // 'box-shadow select-icon border-theme br-5': rfqDetails.serviceType === serviceType.value
                      "box-shadow select-icon border-theme br-5": isSelected(
                        serviceType
                      ),
                    },
                    {
                      // 'box-shadow select-icon border-theme br-5': this.props.rfq.type === 2
                    }
                  )}
                  key={serviceType.value}
                  name={serviceType.value}
                  index={index}
                  onClick={(e) => {
                    handleOnClickServiceType(e, serviceType, index);
                  }}
                >
                  {serviceType.value === 1 && <FTLIcon />}
                  {serviceType.value === 2 && <LCLIcon />}
                  {serviceType.value === 3 && <CourierIcon />}
                  {serviceType.value === 4 && <ContainerIcon />}
                  {serviceType.value === 5 && <ContainerIcon />}
                  {serviceType.value === 6 && <FTLIcon />}
                  {serviceType.value === 7 && <FTLIcon />}
                  {serviceType.value === 8 && <FTLIcon />}
                  {serviceType.value === 9 && <FTLIcon />}

                  <div
                    className={ClassNames("mt-10 fs-16 fBold tCenter", {
                      // 'theme-color ': rfqDetails.serviceType === serviceType.value,
                      // 'label-color ': !(rfqDetails.serviceType === serviceType.value)
                      "theme-color ": isSelected(serviceType),
                      "label-color ": !isSelected(serviceType),
                    })}
                  >
                    <div>{serviceType.name}</div>
                  </div>
                </div>
              }
            </Fragment>
          );
        })}
      </FlexWrapperT14>
    </Fragment>
  );
};

export default ServiceTypeDetails;
